import { css } from "@emotion/react";

export const gallery = css`
  padding-top: 80px;
  padding-bottom: 80px;
  @media (min-width: 600px) {
    padding-top: 128px;
    padding-bottom: 128px;
  }
`;

export const items = css`
  display: grid;
  gap: 32px;
  @media (min-width: 600px) {
    gap: 48px;
  }
`;

export const item = css`
  text-align: center;
  margin-left: -32px;
  margin-right: -32px;
  @media (min-width: 600px) {
    margin: 0;
  }
`;
export const serviceButtonWrapper = css`
  margin-top: 80px;
  height: 44px;
  text-align: center;
  :hover {
    opacity: 0.8;
    transition: all 0.5s;
  }
  @media (min-width: 600px) {
    margin-top: 128px;
    height: 64px;
  }
`;

export const serviceButton = css`
  display: inline-block;
  border-radius: 32px;
  overflow: hidden;
  text-decoration: none;
`;
export const serviceButtonInner = css`
  width: 311px;
  height: 44px;
  line-height: 44px;
  border-radius: 22px;
  color: var(--color-white);
  font-size: 14px;
  font-weight: 600;
  @media (min-width: 600px) {
    width: 320px;
    height: 64px;
    line-height: 64px;
    border-radius: 32px;
    font-size: 20px;
  }
`;
